import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Diamond, CircleNotch } from "@phosphor-icons/react";
import Assembly3D from "@/pages/Assembly3D";
import { useTranslation } from "react-i18next";

export default function Demo() {
  const { t } = useTranslation();
  const [product, setProduct] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.get(`/public/demo`)
      .then((r) => setProduct(r.data))
      .catch((e) => setErr(apiError(e)));
  }, []);

  if (err) return <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center text-neutral-500" data-testid="demo-error">{err}</div>;
  if (!product) return <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center"><CircleNotch size={30} className="animate-spin text-gold" /></div>;

  return (
    <div data-testid="demo-page">
      <div className="w-full bg-obsidian text-white text-center py-2 px-4 text-xs sm:text-sm flex items-center justify-center gap-2" data-testid="demo-banner">
        <Diamond size={14} weight="fill" className="text-gold" />
        <span>{t("demo.banner")}</span>
      </div>
      <Assembly3D product={product} demo />
    </div>
  );
}
